export default __webpack_public_path__ + "static/media/ic_chevron_down_sm.78991ec7.svg";